/* eslint-disable max-lines */
import _ from 'lodash';
import { formatValue } from '@/views/index/config.js';
import {
    getOverdueTypeIndustry,
    getOverdueCustomer,
    getOverdueCustomerLms,
    getOverdueTimeDistribute,
    getOverdueCompanyCustomer
} from '@/api/subPageApi.js';
const commColumns = [{
    label: '应收账款',
    prop: 'arAmt'
}, {
    label: '本月到期',
    prop: 'amtDue'
}, {
    label: '逾期账款',
    prop: 'amtOverdue'
}, {
    label: '逾期率',
    prop: 'overdueRate',
    type: 'slot'
}, {
    label: '责任制逾期率',
    prop: 'dutyOverdueRate',
    type: 'slot'
}, {
    label: '风险计提',
    prop: 'riskAccrual'
}, {
    label: '逾期30天内',
    prop: 'amtOverdue30Day'
}, {
    label: '逾期30天以上',
    prop: 'amtOverdue30T00Day'
}, {
    label: '逾期30-90天',
    prop: 'amtOverdue30T90Day'
}, {
    label: '逾期90-180天',
    prop: 'amtOverdue90T180Day'
}, {
    label: '逾期180天以上',
    prop: 'amtOverdue180Day'
}];
// 外部各行业逾期情况
export const outsideColumnsConfig = {
    height: '200px',
    columns: [{
        label: '行业',
        prop: 'typeName',
        type: 'slot'
    }, ..._.cloneDeep(commColumns)]
};

// 专司逾期情况
export const specialOfficeConfig = {
    height: '200px',
    columns: [{
        label: '专司',
        prop: 'bigEbcdNamed',
        type: 'slot'
    }, ..._.cloneDeep(commColumns)]
};

// 分公司逾期情况
export const branchOfficeColumnsConfig = {
    height: '200px',
    columns: [{
        label: '分公司',
        prop: 'companyShortName',
        type: 'slot'
    }, ..._.cloneDeep(commColumns)]
};
export const searchListConfig = [
    {
        prop: 'ebcdCode',
        name: '专业公司',
        type: 'select',
        placeholder: '请选择专业公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-overdue-search-ebcdCode'
    },
    {
        prop: 'industryCategory',
        name: '行业大类',
        type: 'cascader',
        props: {
            multiple: true,
            value: 'code',
            label: 'name'
        },
        placeholder: '请选择行业大类',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-overdue-search-industryCategory'
    },
    {
        prop: 'areaCode',
        name: '片区',
        type: 'select',
        placeholder: '请选择片区',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-overdue-search-areaCode'
    },
    {
        prop: 'subBranchCode',
        name: '分公司',
        type: 'select',
        placeholder: '请选择分公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-org-overdue-search-subBranchCode'
    },
    // {
    //     prop: 'businessCode',
    //     name: '业务场景',
    //     type: 'select',
    //     placeholder: '请选择业务场景',
    //     multiple: true,
    //     optionsKey: ''
    // },
    {
        prop: 'bigEbcdName',
        name: '大专司',
        type: 'select',
        placeholder: '请选择大专司',
        multiple: false,
        defaultValue: '整体',
        options: [
            {
                code: '整体',
                name: '整体'
            },
            {
                code: '城配送装',
                name: '城配送装'
            },
            {
                code: '零担干线',
                name: '零担干线'
            },
            {
                code: '生产物流',
                name: '生产物流'
            },
            {
                code: '非专司',
                name: '非专司'
            }
        ],
        className: 'bigData-btn-home-sub-org-overdue-search-bigEbcdName'
    },
    {
        prop: 'customerlevelName',
        name: '客户等级',
        type: 'radio',
        placeholder: '请选择客户等级',
        fixed: 'left',
        className: 'bigData-btn-home-sub-org-overdue-search-customerlevelName'
    },
    {
        prop: 'timeStatus',
        name: '时间',
        type: 'time',
        placeholder: '请选择时间',
        fixed: 'left',
        className: 'bigData-btn-home-sub-org-overdue-search-timeStatus'
    }
];
export const updateTimeBigdataList = {
    resetClassName: 'bigData-btn-home-sub-org-overdue-reset',
    closeClassName: 'bigData-btn-home-sub-org-overdue-close'
};
//   =====================外部行业逾期情况弹窗表格配置 start===========================
// 小行业 一级弹窗
export const overdueIndustryCategoryConfig = {
    name: 'incomeIndustryCategory',
    selection: true,
    index: false,
    listApi: getOverdueTypeIndustry,
    monthType: 'dashboard_overdue_type_industry',
    yearType: 'dashboard_overdue_type_industry',
    tableData: {
        columnsMonth: [
            {
                label: '小行业',
                prop: 'industryName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '应收账款',
                prop: 'arAmt'
            }, {
                label: '本月到期',
                prop: 'amtDue',
                type: 'slot'
            }, {
                label: '逾期账款',
                prop: 'amtOverdue',
                type: 'slot'
            }, {
                label: '逾期率',
                prop: 'overdueRate'
            }, {
                label: '责任制逾期率',
                prop: 'dutyOverdueRate'
            }, {
                label: '风险计提',
                prop: 'riskAccrual'
            }, {
                label: '逾期30天内',
                prop: 'amtOverdue30Day'
            }, {
                label: '逾期30天以上',
                prop: 'amtOverdue30T00Day'
            }, {
                label: '逾期30-90天',
                prop: 'amtOverdue30T90Day'
            }, {
                label: '逾期90-180天',
                prop: 'amtOverdue90T180Day'
            }, {
                label: '逾期180天以上',
                prop: 'amtOverdue180Day'
            }
        ],
        columnsYear: [
            {
                label: '小行业',
                prop: 'industryName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '应收账款',
                prop: 'arAmt'
            }, {
                label: '本月到期',
                prop: 'amtDue',
                type: 'slot'
            }, {
                label: '逾期账款',
                prop: 'amtOverdue',
                type: 'slot'
            }, {
                label: '逾期率',
                prop: 'overdueRate'
            }, {
                label: '责任制逾期率',
                prop: 'dutyOverdueRate'
            }, {
                label: '风险计提',
                prop: 'riskAccrual'
            }, {
                label: '逾期30天内',
                prop: 'amtOverdue30Day'
            }, {
                label: '逾期30天以上',
                prop: 'amtOverdue30T00Day'
            }, {
                label: '逾期30-90天',
                prop: 'amtOverdue30T90Day'
            }, {
                label: '逾期90-180天',
                prop: 'amtOverdue90T180Day'
            }, {
                label: '逾期180天以上',
                prop: 'amtOverdue180Day'
            }
        ]
    },
    columnsFunc: (col, monthTime) => {
        // 当前月
        // const currentMonth = `${moment(monthTime).format('MM')}月`;
        // 上个月
        // const prevMonth = `${moment(monthTime).subtract(1, 'month').format('MM')}月`;
        // // 同期上年月
        // const prevYearMonth = `${moment(monthTime).subtract(1, 'year').format('yyyy年MM月')}`;
        // col.forEach(it => {
        //     if (it.prop === 'arAmt') {
        //         it.label = currentMonth + '达成';
        //     }
        // });
        return col;
    },
    afterResponse: (res) => {
        if (res && +res.code === 0) {
            res.data.forEach(it => {
                it.arAmt = formatValue(it.arAmt);
                it.amtDue = formatValue(it.amtDue);
                it.amtOverdue = formatValue(it.amtOverdue);
                it.overdueRate = formatValue(it.overdueRate);
                it.dutyOverdueRate = formatValue(it.dutyOverdueRate);
                it.riskAccrual = formatValue(it.riskAccrual);
                it.amtOverdue30Day = formatValue(it.amtOverdue30Day);
                it.amtOverdue30T00Day = formatValue(it.amtOverdue30T00Day);
                it.amtOverdue30T90Day = formatValue(it.amtOverdue30T90Day);
                it.amtOverdue90T180Day = formatValue(it.amtOverdue90T180Day);
                it.amtOverdue180Day = formatValue(it.amtOverdue180Day);
            });
            const totalItem = res.data.find(it => it.angleName === '合计' || it.lmsCustomerName === '合计');
            if (totalItem) {
                res.data.splice(res.data.indexOf(totalItem), 1);
                res.data.unshift(totalItem);
            }
        }
        return res;
    },
    searchListConfig: [
        {
            prop: 'timeStatus',
            name: '时间',
            type: 'time',
            placeholder: '请选择时间',
            fixed: 'right'
        }
    ]
};

// 客户（系）二级弹窗
export const customerGroupConfig = {
    name: 'overdueIndustryCategory2',
    selection: true,
    index: false,
    listApi: getOverdueCustomer,
    monthType: 'dashboard_overdue_customer',
    yearType: 'dashboard_overdue_customer',
    defaultPage: false,
    page: true,
    tableData: {
        columnsMonth: [
            {
                label: '客户名称',
                prop: 'customerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '客户等级',
                prop: 'customerlevelName',
                align: 'center'
            },
            {
                label: '应收账款',
                prop: 'arAmt',
                align: 'center'
            },
            {
                label: '本月到期',
                prop: 'amtDue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期率',
                prop: 'overdueRate',
                align: 'center'
            },
            {
                label: '风险计提',
                prop: 'riskAccrual',
                align: 'center'
            }
        ],
        columnsYear: [
            {
                label: '客户名称',
                prop: 'customerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '客户等级',
                prop: 'customerlevelName',
                align: 'center'
            },
            {
                label: '应收账款',
                prop: 'arAmt',
                align: 'center'
            },
            {
                label: '本月到期',
                prop: 'amtDue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期率',
                prop: 'overdueRate',
                align: 'center'
            },
            {
                label: '风险计提',
                prop: 'riskAccrual',
                align: 'center'
            }
        ]
    },
    columnsFunc: (col, monthTime) => {
        // 当前月
        // const currentMonth = `${moment(monthTime).format('MM')}月`;
        // 上个月
        // const prevMonth = `${moment(monthTime).subtract(1, 'month').format('MM')}月`;
        // // 同期上年月
        // const prevYearMonth = `${moment(monthTime).subtract(1, 'year').format('yyyy年MM月')}`;
        // col.forEach(it => {
        //     if (it.prop === 'arAmt') {
        //         it.label = currentMonth + '达成';
        //     }
        // });
        return col;
    },
    afterResponse: (res) => {
        if (res && +res.code === 0) {
            res.data.forEach(it => {
                it.arAmt = formatValue(it.arAmt);
                it.amtDue = formatValue(it.amtDue);
                it.amtOverdue = formatValue(it.amtOverdue);
                it.overdueRate = formatValue(it.overdueRate);
                it.riskAccrual = formatValue(it.riskAccrual);
            });
            const totalItem = res.data.find(it => it.angleName === '合计' || it.lmsCustomerName === '合计');
            if (totalItem) {
                res.data.splice(res.data.indexOf(totalItem), 1);
                res.data.unshift(totalItem);
            }
        }
        return res;
    },
    searchListConfig: [
        {
            prop: 'customerlevelName',
            name: '客户等级',
            type: 'radio',
            placeholder: '请选择客户等级',
            fixed: 'right'
        },
        {
            prop: 'timeStatus',
            name: '时间',
            type: 'time',
            placeholder: '请选择时间',
            fixed: 'right'
        }
    ]
};

// 客户详情 三级弹窗
export const customerDetailConfig = {
    name: 'overdueCustomerDetail',
    selection: true,
    index: false,
    monthType: 'dashboard_overdue_customer_lms',
    yearType: 'dashboard_overdue_customer_lms',
    listApi: getOverdueCustomerLms,
    defaultPage: false,
    page: true,
    tableData: {
        columnsMonth: [
            {
                label: '客户名称',
                prop: 'lmsCustomerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '应收账款',
                prop: 'arAmt',
                align: 'center'
            },
            {
                label: '本月到期',
                prop: 'amtDue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期率',
                prop: 'overdueRate',
                align: 'center'
            },
            {
                label: '风险计提',
                prop: 'riskAccrual',
                align: 'center'
            }
        ],
        columnsYear: [
            {
                label: '客户名称',
                prop: 'lmsCustomerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '应收账款',
                prop: 'arAmt',
                align: 'center'
            },
            {
                label: '本月到期',
                prop: 'amtDue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期率',
                prop: 'overdueRate',
                align: 'center'
            },
            {
                label: '风险计提',
                prop: 'riskAccrual',
                align: 'center'
            }
        ]
    },
    columnsFunc: (col, monthTime) => {
        // 当前月
        // const currentMonth = `${moment(monthTime).format('MM')}月`;
        // 上个月
        // const prevMonth = `${moment(monthTime).subtract(1, 'month').format('MM')}月`;
        // // 同期上年月
        // const prevYearMonth = `${moment(monthTime).subtract(1, 'year').format('yyyy年MM月')}`;
        // col.forEach(it => {
        //     if (it.prop === 'arAmt') {
        //         it.label = currentMonth + '达成';
        //     }
        // });
        return col;
    },
    afterResponse: (res) => {
        if (res && +res.code === 0) {
            // 把合计置顶
            res.data.forEach(it => {
                it.arAmt = formatValue(it.arAmt);
                it.amtDue = formatValue(it.amtDue);
                it.amtOverdue = formatValue(it.amtOverdue);
                it.overdueRate = formatValue(it.overdueRate);
                it.riskAccrual = formatValue(it.riskAccrual);
            });
            const totalItem = res.data.find(it => it.angleName === '合计' || it.lmsCustomerName === '合计');
            if (totalItem) {
                res.data.splice(res.data.indexOf(totalItem), 1);
                res.data.unshift(totalItem);
            }
        }
        return res;
    },
    searchListConfig: [
        {
            prop: 'timeStatus',
            name: '时间',
            type: 'time',
            placeholder: '请选择时间',
            fixed: 'right'
        }
    ]
};

//  =====================外部行业逾期情况弹窗表格配置 end===========================

//  =====================专司逾期情况/分公司逾期情况 start===========================
// 客户（系）一级弹窗
export const overdueCompanyCustomerConfig = {
    name: 'overdueIndustryCategory2',
    selection: true,
    index: false,
    listApi: getOverdueCompanyCustomer,
    monthType: 'dashboard_overdue_company_customer',
    yearType: 'dashboard_overdue_company_customer',
    // defaultPage: true,
    page: true,
    tableData: {
        columnsMonth: [
            {
                label: '客户名称',
                prop: 'customerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '客户等级',
                prop: 'customerlevelName',
                align: 'center'
            },
            {
                label: '应收账款',
                prop: 'arAmt',
                align: 'center'
            },
            {
                label: '本月到期',
                prop: 'amtDue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期率',
                prop: 'overdueRate',
                align: 'center'
            },
            {
                label: '风险计提',
                prop: 'riskAccrual',
                align: 'center'
            }
        ],
        columnsYear: [
            {
                label: '客户名称',
                prop: 'customerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '客户等级',
                prop: 'customerlevelName',
                align: 'center'
            },
            {
                label: '应收账款',
                prop: 'arAmt',
                align: 'center'
            },
            {
                label: '本月到期',
                prop: 'amtDue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期率',
                prop: 'overdueRate',
                align: 'center'
            },
            {
                label: '风险计提',
                prop: 'riskAccrual',
                align: 'center'
            }
        ]
    },
    columnsFunc: (col, monthTime) => {
        // 当前月
        // const currentMonth = `${moment(monthTime).format('MM')}月`;
        // 上个月
        // const prevMonth = `${moment(monthTime).subtract(1, 'month').format('MM')}月`;
        // // 同期上年月
        // const prevYearMonth = `${moment(monthTime).subtract(1, 'year').format('yyyy年MM月')}`;
        // col.forEach(it => {
        //     if (it.prop === 'arAmt') {
        //         it.label = currentMonth + '达成';
        //     }
        // });
        return col;
    },
    afterResponse: (res) => {
        if (res && +res.code === 0) {
            res.data.forEach(it => {
                it.arAmt = formatValue(it.arAmt);
                it.amtDue = formatValue(it.amtDue);
                it.amtOverdue = formatValue(it.amtOverdue);
                it.overdueRate = formatValue(it.overdueRate);
                it.riskAccrual = formatValue(it.riskAccrual);
            });
            const totalItem = res.data.find(it => it.angleName === '合计' || it.lmsCustomerName === '合计');
            if (totalItem) {
                res.data.splice(res.data.indexOf(totalItem), 1);
                res.data.unshift(totalItem);
            }
        }
        return res;
    },
    searchListConfig: [
        {
            prop: 'customerlevelName',
            name: '客户等级',
            type: 'radio',
            placeholder: '请选择客户等级',
            fixed: 'right'
        },
        {
            prop: 'timeStatus',
            name: '时间',
            type: 'time',
            placeholder: '请选择时间',
            fixed: 'right'
        }
    ]
};

// 逾期时间分布 二级弹窗
export const overdueTimeDistributeConfig = {
    name: 'overdueTimeDistribute',
    selection: true,
    index: false,
    monthType: 'dashboard_overdue_time_distribute',
    yearType: 'dashboard_overdue_time_distribute',
    listApi: getOverdueTimeDistribute,
    pageSize: 300,
    page: false,
    tableData: {
        columnsMonth: [
            {
                label: '客户名称',
                prop: 'lmsCustomerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期30天内',
                prop: 'amtOverdue30Day',
                align: 'center'
            },
            {
                label: '逾期30-90天',
                prop: 'amtOverdue30T90Day',
                align: 'center'
            },
            {
                label: '逾期90-180天',
                prop: 'amtOverdue90T180Day',
                align: 'center'
            },
            {
                label: '逾期180天以上',
                prop: 'amtOverdue180Day',
                align: 'center'
            }
        ],
        columnsYear: [
            {
                label: '客户名称',
                prop: 'lmsCustomerName',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期账款',
                prop: 'amtOverdue',
                align: 'center',
                type: 'slot'
            },
            {
                label: '逾期30天内',
                prop: 'amtOverdue30Day',
                align: 'center'
            },
            {
                label: '逾期30-90天',
                prop: 'amtOverdue30T90Day',
                align: 'center'
            },
            {
                label: '逾期90-180天',
                prop: 'amtOverdue90T180Day',
                align: 'center'
            },
            {
                label: '逾期180天以上',
                prop: 'amtOverdue180Day',
                align: 'center'
            }
        ]
    },
    columnsFunc: (col, monthTime) => {
        // 当前月
        // const currentMonth = `${moment(monthTime).format('MM')}月`;
        // 上个月
        // const prevMonth = `${moment(monthTime).subtract(1, 'month').format('MM')}月`;
        // // 同期上年月
        // const prevYearMonth = `${moment(monthTime).subtract(1, 'year').format('yyyy年MM月')}`;
        // col.forEach(it => {
        //     if (it.prop === 'arAmt') {
        //         it.label = currentMonth + '达成';
        //     }
        // });
        return col;
    },
    afterResponse: (res) => {
        if (res && +res.code === 0) {
            res.data.forEach(it => {
                it.amtOverdue = formatValue(it.amtOverdue);
                it.amtOverdue30Day = formatValue(it.amtOverdue30Day);
                it.amtOverdue30T90Day = formatValue(it.amtOverdue30T90Day);
                it.amtOverdue90T180Day = formatValue(it.amtOverdue90T180Day);
                it.amtOverdue180Day = formatValue(it.amtOverdue180Day);
            });
            const totalItem = res.data.find(it => it.angleName === '合计' || it.lmsCustomerName === '合计');
            if (totalItem) {
                res.data.splice(res.data.indexOf(totalItem), 1);
                res.data.unshift(totalItem);
            }
        }
        return res;
    },
    searchListConfig: [
        {
            prop: 'timeStatus',
            name: '时间',
            type: 'time',
            placeholder: '请选择时间',
            fixed: 'right'
        }
    ]
};
//  =====================专司逾期情况/分公司逾期情况 end===========================
